export * from './DocsIcon';
export * from './DocsIcon16Light';
export * from './DocsIcon16Regular';
export * from './DocsIcon16Solid';
export * from './DocsIcon20Light';
export * from './DocsIcon20Regular';
export * from './DocsIcon20Solid';
export * from './DocsIcon24Regular';
export * from './DocsIcon24Solid';
export * from './DocsIcon32Regular';
export * from './DocsIcon64Regular';
